import React from "react";

const UserRunning = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M21.26 9.276h6.527l-1.67-2.098H19.59l1.67 2.098ZM9.51 9.12A3.812 3.812 0 0 1 8.06 3.943a3.773 3.773 0 0 1 5.151-1.456 3.812 3.812 0 0 1 1.449 5.177 3.773 3.773 0 0 1-5.15 1.455Zm22.82 6.716L34 17.934h-6.526l-1.67-2.099h6.525Zm-9.345-4.329h6.526l1.67 2.1h-6.526l-1.67-2.1Zm-19.63 4.916 4.436-.183 3.128-5.57 2.189-1.255c.373-.195 1.668-.948 2.95.076l8.192 6.845c.612.569.996 1.436.188 2.37-.563.634-1.536.575-2.131.114l-5.492-4.964.71 4.514 3.324 6.095 4.869 2.616c1.476 1.076.881 2.294.64 2.631-.361.507-1.371 1.234-2.549.5l-6.13-3.729-2.323-4.304-4.1 3.327.238 6.802c-.03 1.048-.961 1.687-1.776 1.693-1.06-.026-1.729-.699-1.826-1.854l-.19-5.712c-.029-1.076-.246-2.398.546-3.09l4.132-3.705-.749-3.807-2.468 3.437-5.461.26c-1.143.043-1.653-.803-1.695-1.506-.083-.84.677-1.508 1.348-1.601Z"
            fill={fill}
        />
    </svg>
);

export default UserRunning;